import { subDays } from "date-fns";
import { proxy, subscribe } from "valtio";

import { LocalStorage } from "@/app/utils/localStorage";

export namespace completedState {
  const storage = new LocalStorage("completedFilter");

  export const completedFilter = proxy<{ dateKey: CompletedFilterOption }>(
    storage.get({ fallback: { dateKey: "days3" } }), // default to 3 days
  );

  export const actions = proxy({
    count: null as number | null,
  });

  subscribe(completedFilter, () => {
    storage.save(completedFilter);
  });

  export const dates = {
    today: subDays(new Date(), 1),
    days3: subDays(new Date(), 3),
    week: subDays(new Date(), 7),
  };

  export const dateLabels: Record<CompletedFilterOption, string> = {
    today: "Today",
    days3: "3 Days",
    week: "7 Days",
  };

  export type CompletedFilterOption = keyof typeof completedState.dates;
}
